import React, { useState, useEffect } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../App";
import { useNavigate } from "react-router-dom";

const translations = {
  ENGLISH: {
    finalRemark: "Final Remark",
    select: "Select",
    positive: "Positive",
    negative: "Negative",
    referToCredit: "Refer to Credit",
    descriptionSummary: "Description/Summary",
    latitude: "Latitude",
    longitude: "Longitude",
    nearbyAddress: "Nearby Address",
    distanceFromBranch: "Distance from the Branch",
    allocatedOn: "Allocated On",
  },
  HINDI: {
    finalRemark: "अंतिम टिप्पणी",
    select: "चुनें",
    positive: "सकारात्मक",
    negative: "नकारात्मक",
    referToCredit: "क्रेडिट को संदर्भित करें",
    descriptionSummary: "विवरण/सारांश",
    latitude: "अक्षांश",
    longitude: "देशान्तर",
    nearbyAddress: "निकटतम पता",
    distanceFromBranch: "शाखा से दूरी",
    allocatedOn: "आवंटित किया गया",
  },
  GUJARATI: {
    finalRemark: "અંતિમ ટિપ્પણી",
    select: "પસંદ કરો",
    positive: "સકારાત્મક",
    negative: "નકારાત્મક",
    referToCredit: "ક્રેડિટ ને સંદર્ભ",
    descriptionSummary: "વર્ણન/સારાંશ",
    fetchLocation: "સ્થાન મેળવો",
    latitude: "અક્ષાંશ",
    longitude: "રેખાંશ",
    nearbyAddress: "નજીકનો સરનામું",
    distanceFromBranch: "શાખાથી અંતર",
    allocatedOn: "Allocated On",
  }
};

export default function Page4() {
  const navigate = useNavigate();
  const [cpvLanguage, setCpvLanguage] = useState("ENGLISH");

  useEffect(() => {
    const language = localStorage.getItem("cpvLanguage");
    setCpvLanguage(language);
  }, []);

  const [finalRemark, setFinalRemark] = useState("");
  const [descriptionSummary, setDescriptionSummary] = useState("");
  const [locationDetails, setLocationDetails] = useState("");
  const [latitudeCPV,setLatitudeCPV] = useState("");
  const [longitudeCPV,setLongitudeCPV] = useState("");
  const [distanceFromBranch, setDistanceFromBranch] = useState("");
  const [allocatedOn, setAllocatedOn] = useState("");
  const [satelliteImages, setSatelliteImages] = useState("");

  const getLocation = () => {
    let s= new Date().toLocaleString();
    setAllocatedOn(s);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      toast.error("Geolocation is not supported by this browser");
    }
  };

  const showPosition = (position) => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLatitudeCPV(latitude);
    setLongitudeCPV(longitude);
    axios
      .post(url + "/api/fetch/google/api/distance", {
        companyCode: localStorage.getItem("CodeCPV"),
        lat: latitude,
        long: longitude,
      })
      .then((res) => {
        if (res.data.auth === true) {
          console.log(res);
          setDistanceFromBranch(res.data.km);
          setSatelliteImages(res.data.satelliteImageUrl)
          axios
            .get(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyC70XNjNzLK1dlbYP58HHqTABdstp8X6U0`
            )
            .then((response) =>
              setLocationDetails(response.data.results[0].formatted_address)
            )
            .catch((err) => {
              console.log(err);
            });
        } else {
          toast.error(res.data.msg);
          console.log(res);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message);
      });
  };

  function showError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        toast.error("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        toast.error("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        toast.error("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        toast.error("An unknown error occurred.");
        break;
      default:
        toast.error("Please contact Tech Support");
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (locationDetails === "") {
      toast.error("Please Fetch Location before proceeding");
      return;
    }
    localStorage.setItem("FinalRemarkCPV", finalRemark);
    localStorage.setItem("DescriptionSummaryCPV", descriptionSummary);
    localStorage.setItem("LocationDetailsCPV", locationDetails);
    localStorage.setItem("LatitudeCPV", latitudeCPV);
    localStorage.setItem("LongitudeCPV", longitudeCPV);
    localStorage.setItem("DistanceFromBranchCPV", distanceFromBranch);
    localStorage.setItem("AllocatedOnCPV", allocatedOn);
    localStorage.setItem("SatelliteImages", satelliteImages);
    navigate("/5");
  };
  
  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-login">
        <form onSubmit={handleSubmit}>
          <div
            style={{
              fontWeight: "bolder",
              fontSize: "1.5rem",
              margin: ".5rem 0",
            }}
          >
            Summary
          </div>
          <div className="div-login">
            {/* <label>
              Final Remark <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].finalRemark} <span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              required
              value={finalRemark}
              onChange={(e) => setFinalRemark(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Positive">{translations[cpvLanguage].positive}</option>
              <option value="Negative">{translations[cpvLanguage].negative}</option>
              <option value="Refer to Credit">{translations[cpvLanguage].referToCredit}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>Description/Summary</label> */}
            <label>{translations[cpvLanguage].descriptionSummary} <span style={{ color: "red" }}>*</span></label>
            <textarea
              type="text"
              rows="4"
              value={descriptionSummary}
              onChange={(e) => setDescriptionSummary(e.target.value)}
            ></textarea>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button className="btn-login" type="button" onClick={getLocation}>
              Fetch Location
            </button>
          </div>
          <div className="div-login">
            {/* <label>
              Latitude <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].latitude} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              value={latitudeCPV}
              disabled
            />
          </div>
          <div className="div-login">
            {/* <label>
              Longitude <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].longitude} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              value={longitudeCPV}
              disabled
            />
          </div>
          <div className="div-login">
            {/* <label>
              Nearby Address <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].nearbyAddress} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              value={locationDetails}
              // onChange={(e) => setLocationDetails(e.target.value)}
              disabled
            />
          </div>
          <div className="div-login">
            {/* <label>
              Distance from the Branch <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].distanceFromBranch} <span style={{ color: "red" }}>*</span></label>
            <input type="text" required disabled value={distanceFromBranch} />
          </div>
          <div className="div-login">
            {/* <label>Allocated On</label> */}
            <label>{translations[cpvLanguage].allocatedOn}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              disabled
              value={allocatedOn}
              onChange={(e) => setAllocatedOn(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button className="btn-login" type="submit">
              Proceed
            </button>
          </div>
        </form>
      </div>
      <ToastContainer position="top-center" />
    </div>
  );
}
